/** Largest width Shopify's image CDN will serve. */
const MAX_CDN_WIDTH = 5760

/**
 * Cart AJAX payloads carry the unresized master URL, so a thumbnail slot
 * downloads the full-size asset unless this re-requests it at an explicit width.
 */
export function cdnImageUrl (url, width) {
  if (typeof url !== 'string' || url === '') return url
  if (!Number.isInteger(width) || width < 1 || width > MAX_CDN_WIDTH) return url
  if (/[?&]width=/.test(url)) return url
  return `${url}${url.includes('?') ? '&' : '?'}width=${width}`
}
